import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PURCHASERS = gql`
  query MasterDataPurchasers($params: MasterDataPurchasersParamsInput!) {
    masterDataPurchasers(params: $params) {
      items {
        purchaserId
        purchaserKey
        purchaserName
        isActive
        metadata
        searchKeywords
        defaultProductCategoryId
        defaultProductCategoryName
        intelligenceFilter
        discountPercentageCredit
        deductionTypeInvoicePatternForDiscount
        discountPercentageDeduction
        discountTermAgreementDays
        additionalFieldMapping
        discountTermAgreementDaysTolerance
        distributionCentersCount
      }
    }
  }
`;
